var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, FormField, Input, InputList, InputDob, Modal } from '../../shared';
import { services, validation } from '../../../shared';
import './edit-client.scss';
import { InputAddressAddClient, isValidAddress, } from '../../../components/shared/input-types/input-address_addclient/input-address_addclient';
export var EditClient = function (_a) {
    var _b, _c;
    var handleClose = _a.handleClose, show = _a.show, client = _a.client, titles = _a.titles, fetchCustomers = _a.fetchCustomers, onUpdate = _a.onUpdate, updateApplicants = _a.updateApplicants, caseView = _a.caseView, resetForm = _a.resetForm, isReset = _a.isReset, refreshClientDetails = _a.refreshClientDetails;
    var defaultValues = {
        title: null,
        firstName: '',
        lastName: '',
        dobDay: '',
        dobMonth: '',
        dobYear: '',
        emailAddress: '',
        contactNumber: '',
        propertyName: '',
        propertyNumber: '',
        road: '',
        town: '',
        county: '',
        postCode: '',
        postcodeLookup: '',
    };
    var _d = useForm({ defaultValues: defaultValues }), register = _d.register, handleSubmit = _d.handleSubmit, errors = _d.errors, setValue = _d.setValue, watch = _d.watch, reset = _d.reset, setError = _d.setError;
    var _e = useState(false), isSubmitted = _e[0], setSubmitted = _e[1];
    var _f = useState([]), apisInProgress = _f[0], setApisInProgress = _f[1];
    var close = function () {
        handleClose();
        if (!caseView) {
            resetForm(false);
            reset();
        }
    };
    var onSubmit = function (data, event) { return __awaiter(void 0, void 0, void 0, function () {
        var address, customerDetail, res;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!!isSubmitted) return [3 /*break*/, 2];
                    if (!isValidAddress(data)) {
                        if (!data.postcodeLookup)
                            setError('postcodeLookup', { message: 'Please enter a valid post code' });
                        if (data.postcodeLookup && !data.propertyName && !data.propertyNumber)
                            setError('postcodeLookup', { message: 'Please click find' });
                        return [2 /*return*/];
                    }
                    address = {
                        id: (_a = client === null || client === void 0 ? void 0 : client.addressId) !== null && _a !== void 0 ? _a : 0,
                        propertyName: data.propertyName,
                        propertyNumber: data.propertyNumber,
                        road: data.road,
                        town: data.town,
                        county: data.county,
                        postCode: data.postCode,
                    };
                    customerDetail = {
                        id: (_b = client === null || client === void 0 ? void 0 : client.id) !== null && _b !== void 0 ? _b : 0,
                        titleId: parseInt(data.title.toString()),
                        firstName: data.firstName,
                        surname: data.lastName,
                        dateOfBirth: new Date(Date.UTC(parseInt(data.dobYear), parseInt(data.dobMonth) - 1, parseInt(data.dobDay))).toISOString(),
                        email: data.emailAddress,
                        mobileNumber: data.contactNumber,
                        addressId: client === null || client === void 0 ? void 0 : client.addressId,
                        address: address,
                        correspondenceAddress: address,
                        applicantId: client === null || client === void 0 ? void 0 : client.applicantId,
                    };
                    setApisInProgress(function (ps) { return __spreadArray(__spreadArray([], ps, true), [services.saveClient], false); });
                    return [4 /*yield*/, services.saveClient(customerDetail)];
                case 1:
                    res = _c.sent();
                    if (!(res === null || res === void 0 ? void 0 : res.error) && caseView == true) {
                        setSubmitted(true);
                        updateApplicants(customerDetail);
                        onUpdate(customerDetail);
                    }
                    if (!caseView) {
                        refreshClientDetails(customerDetail === null || customerDetail === void 0 ? void 0 : customerDetail.id);
                    }
                    setApisInProgress(function (ps) { return ps.filter(function (val) { return val !== services.saveClient; }); });
                    close();
                    _c.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        document.querySelector('.modal-main-body').scrollTo(0, 0);
        setSubmitted(false);
        if (show && !client && isReset) {
            resetForm(false);
            reset();
        }
    }, [client, isReset]);
    return (React.createElement(Modal, { title: client == null ? 'Add a new client' : 'Edit your client', show: show, handleClose: close, scrollable: true },
        React.createElement("form", { onSubmit: handleSubmit(onSubmit), noValidate: true, className: "modal-main-form" },
            React.createElement("fieldset", null,
                React.createElement("legend", null, "Edit client"),
                React.createElement(FormField, { label: "Title", error: errors.title && validation.title.message },
                    React.createElement(InputList, { id: "title", options: titles, legend: "Select a title", forceSelection: true, error: !!errors.title, required: validation.title.types.required, ref: register(validation.title.types), setValue: setValue, value: (_b = client === null || client === void 0 ? void 0 : client.titleId) === null || _b === void 0 ? void 0 : _b.toString() })),
                React.createElement(FormField, { id: "firstName", label: "First name", error: errors.firstName && validation.firstName.message },
                    React.createElement(Input, { id: "firstName", error: !!errors.firstName, required: validation.firstName.types.required, ref: register(validation.firstName.types), setValue: setValue, value: client === null || client === void 0 ? void 0 : client.firstName })),
                React.createElement(FormField, { id: "lastName", label: "Last name", error: errors.lastName && validation.lastName.message },
                    React.createElement(Input, { id: "lastName", error: !!errors.lastName, required: validation.lastName.types.required, ref: register(validation.lastName.types), setValue: setValue, value: client === null || client === void 0 ? void 0 : client.surname })),
                React.createElement(FormField, { label: "Date of birth", error: (errors.dobDay || errors.dobMonth || errors.dobYear) && validation.dob.message },
                    React.createElement(InputDob, { register: register, setValue: setValue, value: client === null || client === void 0 ? void 0 : client.dateOfBirth, required: validation.dob.types.required, errors: errors, name: "dob", isReset: isReset })),
                ' ',
                React.createElement(InputAddressAddClient, { register: register, errors: errors, setValue: setValue, required: true, watch: watch, value: (_c = client === null || client === void 0 ? void 0 : client.addressId) === null || _c === void 0 ? void 0 : _c.toString(), isReset: isReset, setError: setError }),
                React.createElement(FormField, { id: "emailAddress", label: "Email address", error: errors.emailAddress && validation.emailAddress.message },
                    React.createElement(Input, { type: "email", id: "emailAddress", required: validation.emailAddress.types.required, error: !!errors.emailAddress, ref: register(validation.emailAddress.types), setValue: setValue, value: client === null || client === void 0 ? void 0 : client.email })),
                React.createElement(FormField, { id: "contactNumber", label: "Contact number", error: errors.contactNumber && validation.contactNumber.message },
                    React.createElement(Input, { type: "tel", id: "contactNumber", required: validation.contactNumber.types.required, error: !!errors.contactNumber, ref: register(validation.contactNumber.types), setValue: setValue, value: client === null || client === void 0 ? void 0 : client.mobileNumber })),
                React.createElement(Button, { type: "submit", variant: "primary", disabled: apisInProgress.includes(services.saveClient), childClasses: "u-mr-2 button" }, client == null ? 'Add client' : 'Update client'),
                React.createElement(Button, { type: "button", variant: "bare", size: "small", onClick: close }, "Cancel")))));
};
